import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./modal.scss";

export const DeleteOrderModal = ({
  handleClose,
  show,
  handleDelete,
  selectedId,
}) => {
  return (
    <div>
      <Modal show={show} onHide={handleClose} className="z-50" centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete Order# {selectedId}?
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
            onClick={handleDelete}
            variant="primary"
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
